const MINUTE_MS = 60_000

export function getCurrentMinuteBucketMs(now = Date.now()): number {
	return Math.floor(now / MINUTE_MS) * MINUTE_MS
}

export function getDelayUntilNextMinuteBucketMs(now = Date.now()): number {
	const msIntoMinute = now % MINUTE_MS

	if (msIntoMinute === 0) {
		return MINUTE_MS
	}

	return MINUTE_MS - msIntoMinute
}
